import "./SuggestionMessage.scss";

const SuggestionMessage = ({message, children, className, style}) => {
	return (
		<div className={`suggestion-message${className ? ' ' + className : ''}`} style={style}>
			<p>{message || children}</p>
		</div>
	);
}

export default SuggestionMessage;